import { PrimaryKeyId } from "../brands.model";

export type ITenantInvite = {
  readonly id: PrimaryKeyId;
  readonly firstname: string;
  readonly lastname: string;
  readonly emailAddress: string;
  readonly status: string;
  readonly createDate: number;
};

/**
 * - Accepted
 * - Rejected
 * - Cancelled
 * - Pending
 */
export enum IUserInviteStatus {
  accept = "Accepted",
  reject = "Rejected",
  cancel = "Cancelled",
  pending = "Pending",
}

export type IUserInvite = {
  readonly id: PrimaryKeyId;
  readonly tenantId: number;
  readonly emailAddress: string;
  readonly company: string;
  readonly status: IUserInviteStatus;
  readonly createDate: number;
};

export interface ISendInvite {
  /** Requried to resend */
  id?: PrimaryKeyId | null;
  /** An Email! */
  email: string;
  /** Requires id to be passed in */
  resend: boolean;
}
